<template lang="html">

  <section class="idioma">
    <img class="bandera" @click="requestLangChange" :src="`/static/img/change-to-${lang}.png`">
  </section>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  import texts from '@/translations'

  import router from '@/router'

  export default  {
    name: 'idioma',
    props: [],
    mounted() {

    },
    data() {
      return {
          oldLang : ''
      }
    },
    methods: {
      ...mapActions(['changeLanguage']),
      requestLangChange : function(){
        this.oldLang = this.lang;
        this.changeLanguage(this.lang)
        .then(r => {
          this.$i18n.locale = r;
          this.changePath(); 
        }).catch(e =>{
          console.log(e);
        })
      },
      changePath : function (){

        let enlaces = texts[this.oldLang].enlaces;
        let path;
        let newPath;
        

        for(let e in enlaces){
          (enlaces[e] == this.$route.path) ? path = e : '';
        }

        if(!!path){
          newPath = texts[this.lang].enlaces[path];
          router.push(newPath); 
        }
      },
    },
    computed: {
      ...mapGetters({
        lang : 'getLanguage'
      })
    }
  }
</script>

<style scoped  >
.language {
  text-align: right;
} 
.bandera{
  max-width: 40px;
  width: 100%;
}

@media screen and (max-width: 1024px){
  .language{
    text-align: center;
  }
}
@media only screen and (max-width: 500px) {
  .bandera{
    width: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/footer-parts/idioma.vue